import { render } from "./EditExtraService.vue?vue&type=template&id=b91a3e78&scoped=true"
import script from "./EditExtraService.vue?vue&type=script&lang=js"
export * from "./EditExtraService.vue?vue&type=script&lang=js"

import "./EditExtraService.vue?vue&type=style&index=0&id=b91a3e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b91a3e78"]])

export default __exports__